import React from 'react'
import { Button, notification } from 'antd'
import { Route } from 'react-router-dom'

import { ItemList } from '~components'
import { getCurrentUser } from '~context'
import { PageLayout } from '~stories'
import { getGradientCss } from '~utils/flagColor'

const NOTIFICATION_MESSAGES = {
  UNAUTHORIZED: 'You are not authorized to perform this action.'
}
const PAGE_TITLE = 'Flags'

const SWATCH_STYLE = {
  border: '1px solid #d9d9d9',
  borderRadius: 3,
  display: 'inline-block',
  height: 16,
  marginRight: 8,
  verticalAlign: 'middle',
  width: 24
}

const getFlagsNameWithLink = flag => <a href={`flags/${flag._id}/edit`}>{String(flag?.title).toUpperCase()}</a>

const getFlagsDescriptionAsHTML = flag => <div dangerouslySetInnerHTML={{ __html: flag?.html_description }}/>

const getFlagsColor = flag => {
  const gradientCss = getGradientCss(flag?.background_gradient)
  const solidValue = flag?.color?.value
  const background = gradientCss || solidValue
  const label = gradientCss ? 'Gradient' : (solidValue || '—')
  return (
    <span>
      <span style={background ? { ...SWATCH_STYLE, background } : SWATCH_STYLE} />
      {label}
    </span>
  )
}

const columnData = [
  {
    dataIndex: 'title',
    render: (text, flag) => getFlagsNameWithLink(flag),
    sorter: true,
    title: 'Title',
    width: '30%',
    sortDirections: ['descend', 'ascend', 'descend']
  },
  {
    title: 'Description',
    width: '40%',
    render: flag => getFlagsDescriptionAsHTML(flag)
  },
  {
    title: 'Color',
    width: '15%',
    render: flag => getFlagsColor(flag)
  },
  {
    dataIndex: 'app_name',
    title: 'App',
    width: '30%'
  }
]

const addNewFlag = isContentEditor => {
  return (
    <Route render={({ history }) => (
      <Button
        key="1"
        onClick={() => {
          isContentEditor
            ? history.push('/flags/new')
            : notification.error({ message: NOTIFICATION_MESSAGES.UNAUTHORIZED })
        }}
        type="primary"
      >
        Add Flag
      </Button>
    )} />
  )
}

const Flags = () => {
  const { userDetails: { isContentEditor } } = getCurrentUser()

  return (
    <PageLayout extra={[
      addNewFlag(isContentEditor)
    ]} title={PAGE_TITLE}>
      <div className="sponsors-layout-background">
        <ItemList columns={columnData} resource='flags' />
      </div>
    </PageLayout>
  )
}

export default Flags
